import { render, staticRenderFns } from "./RestPassword.vue?vue&type=template&id=bd8b83f4&scoped=true&"
import script from "./RestPassword.vue?vue&type=script&lang=js&"
export * from "./RestPassword.vue?vue&type=script&lang=js&"
import style0 from "./RestPassword.vue?vue&type=style&index=0&id=bd8b83f4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8b83f4",
  null
  
)

export default component.exports